import styled from 'styled-components'
import Thumbnail from './Thumbnail'
import { black, textMuted } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { text } from '@/theme/typography'
import { Pill } from '@components/Pill'

/**
 * Stacked stay rows (design `.bento-rows`): always top-aligned with a fixed
 * gap, so adding a third stay never re-spaces the first two — rows keep the
 * same rhythm at any count and leftover tile height stays at the bottom.
 */
export const StayRows = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`

/** One stay row: 92×92 photo + text block (design `.bento-media-row`). */
export const StayRow = styled.div`
	display: flex;
	gap: 14px;
	align-items: center;
	min-width: 0;
`

export const StayThumb = styled(Thumbnail)`
	width: 92px;
	height: 92px;

	${media.phone} {
		width: 72px;
		height: 72px;
	}
`

export const StayText = styled.div`
	min-width: 0;
`

export const StayName = styled.div`
	${text.label}
	color: ${black};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

export const StayCity = styled.div`
	${text.caption}
	color: ${textMuted};
	margin-top: 2px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`

export const StayDateChip = styled(Pill).attrs({ $tone: 'soft' as const })`
	margin-top: 5px;
`
